import request from "@/utils/request";

// 列表(主数据列表)
export function loadMarketProductPlanListDataApi(data) {
  return request({
    url: "web/marketProductPlan/listData",
    method: "post",
    data
  });
}
// 导出
export function loadMarketProductPlanExportDataApi(data) {
  return request({
    url: "web/marketProductPlan/exportData",
    method: "post",
    data
  });
}
// 初始化
export function initMarketProductPlanApi(data) {
  return request({
    url: "web/marketProductPlan/init",
    method: "post",
    data
  });
}
// 操作
export function saveOrUpdateMarketProductPlanApi(data) {
  return request({
    url: "web/marketProductPlan/saveOrUpdate",
    method: "post",
    data
  });
}
